import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { Invoice, InvoiceModel } from '../../models/InvoiceModel';
import { DailyReport } from '../../models/DailyReport/DailyReportModel';
import { DailyReportInvoicesContext } from '../../screens/dailyReport/DailyReportDetailScreen';
import DailyReportInvoiceList from '../common/DailyReport/DailyReportInvoiceList';

interface Props {
  dailyReport: DailyReport | null;
  ymd: string;
}

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    marginTop: theme.spacing(1),
  },
  jobType: {
    color: theme.palette.error.main,
    fontWeight: 'bold',
  },
  price: {
    color: theme.palette.success.main,
    fontWeight: 'bold',
    fontSize: '1.2rem',
  },
  smallText: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
  },
  divider: {
    margin: `${theme.spacing(1)}px 0`,
  },
}));

/**
 * 日報の請求一覧テーブル
 * @param props
 * @returns
 */
const DailyReportInvoiceTable = (props: Props) => {
  const classes = useStyles();
  const { ymd, dailyReport } = props;
  const { dailyReportInvoices, setDailyReportInvoices } = useContext(DailyReportInvoicesContext);

  // const [invoices, setInvoices] = useState<Invoice[]>([]);

  /**
   * 指定日の請求を取得する
   */

  const onTestReload = () => {
    console.log('reload:', dailyReportInvoices);
    // setDailyReportInvoices([]);
    // fetchDayInvoices();
  };

  const onDelete = (invoice: Invoice) => {
    setDailyReportInvoices(
      dailyReportInvoices.filter(existingInvoice => {
        return existingInvoice.id !== invoice.id;
      })
    );
  };

  useEffect(() => {
    console.log('dailyReportCalled', dailyReport);
    console.log('dailyReportInvoicesCalled', dailyReportInvoices);
    // if (dailyReport == null) {
    //   fetchDayInvoices();
    //   return;
    // }
  }, [dailyReport]);

  return <DailyReportInvoiceList invoices={dailyReportInvoices} onRemove={onDelete} />;
};

export default DailyReportInvoiceTable;
